import { ToastMethods } from "components/ToastNotification";
import i18n from "i18n";
import { action, observable } from "mobx";
import type { SchoolyearDashboard } from "models/schoolyear/Schoolyear";
import { schoolyearRepository } from "repositories";

interface SchoolyearInterface {
  loading: boolean;
  schoolyearDashboard: SchoolyearDashboard;
  activeSchoolyearSignature: string | null;

  fetchSchoolyearDashboard: (scheduledTestId: number) => Promise<string | null>;
  fetchActiveSchoolyearSignature: () => void;

  setLoading: (isLoading: boolean) => void;
  setSchoolyearDashboard: (schoolyearDashboard: SchoolyearDashboard) => void;
  setActiveSchoolyearSignature: (schoolyearSignature: string | null) => void;
}

const initialState = {
  loading: false,
  activeSchoolyearSignature: null,
};

const stateSetters = {
  setSchoolyearDashboard: action((schoolyearDashboard: SchoolyearDashboard) => {
    store.schoolyearDashboard = schoolyearDashboard;
  }),
  setLoading: action((loading: boolean) => {
    store.loading = loading;
  }),
  setActiveSchoolyearSignature: action((schoolyearSignature: string | null) => {
    store.activeSchoolyearSignature = schoolyearSignature;
  }),
};

const apiRequests = {
  fetchSchoolyearDashboard: action((scheduledTestId: number): Promise<string | null> => {
    store.setLoading(true);
    return schoolyearRepository
      .getSchoolyearDashboard(scheduledTestId)
      .then((schoolyearDashboard) => {
        store.setSchoolyearDashboard(schoolyearDashboard);
        return schoolyearDashboard.url;
      })
      .catch(() => {
        ToastMethods.showToast(
          i18n.t("toast:scheduledTest.error.fetchSchoolyearDashboard"),
          "error",
        );
        return null;
      })
      .finally(() => {
        store.setLoading(false);
      });
  }),
  // Fetch Schoolyear signature from headers to identify if user is currently using Schoolyear app
  fetchActiveSchoolyearSignature: action(() => {
    store.setLoading(true);
    schoolyearRepository
      .getSchoolyearSignature()
      .then((signature: string) => {
        store.setActiveSchoolyearSignature(signature);
      })
      .finally(() => {
        store.setLoading(false);
      });
  }),
};

const store = observable({
  ...initialState,
  ...stateSetters,
  ...apiRequests,
} as SchoolyearInterface);

export const useSchoolyear = (): SchoolyearInterface => store;
